// Auto-generated by scripts/prepare-spfx-build.mjs. Do not edit manually.
export interface IBuildInfo {
  readonly solutionVersion: string;
  readonly manifestVersion: string;
  readonly buildVersion: string;
  readonly buildCounter: number;
  readonly buildKind: 'dev' | 'ship';
  readonly builtAtUtc: string;
  readonly requiredSchemaVersion: string;
  readonly acceptsNewerMinorSchema: boolean;
}

export const BUILD_INFO: IBuildInfo = {
  solutionVersion: '1.2.1.45',
  manifestVersion: '1.2.1.45',
  buildVersion: '1.2.1.1',
  buildCounter: 1,
  buildKind: 'ship',
  builtAtUtc: '2026-09-29T14:10:27.506Z',
  requiredSchemaVersion: 'Edinshall-Audit-2.11',
  acceptsNewerMinorSchema: true
};

export default BUILD_INFO;
